module.exports = {
      id: "linkedin-square-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-ef78f60979ae5731dcbbb0aa5aa86923.svg#linkedin-square",
      toString: function () {
        return this.url;
      }
    }